"use strict";
const React = require('react');
const alarm_1 = require('material-ui/svg-icons/action/alarm');
const hourglass_empty_1 = require('material-ui/svg-icons/action/hourglass-empty');
const m = require('../models');
const taskUtils = require('../utils/task');
const c = require('./theme/colors');
// Used when passing icons into material-ui's button components so that the
// icon has its styling applied.
exports.buildGoalIcon = (props) => {
    const task = props.task;
    const goalType = props.goalType || (task && task.goal.type);
    if (goalType === 0 /* NONE */ || (task && task.goal.duration === 0)) {
        return null;
    }
    const style = buildStyle(props);
    switch (goalType) {
        case 1 /* AT_LEAST */:
            return React.createElement(alarm_1.default, {style: Object.assign({}, style, { paddingRight: '4px' }), color: style.color});
        case 2 /* AT_MOST */:
            return React.createElement(hourglass_empty_1.default, {style: style, color: style.color});
        default:
            return null;
    }
};
const buildStyle = (props) => ({
    color: getGoalIconColor(props),
    verticalAlign: 'middle',
});
const getGoalIconColor = (props) => {
    if (props.isSelected) {
        return c.blue;
    }
    if (props.task) {
        return taskUtils.getGoalStatusColor(props.task);
    }
    return c.black;
};



/** WEBPACK FOOTER **
 ** ./src/components/GoalIcon.tsx
 **/